<template>
  <div class="locale-switcher">
    <select v-model="$i18n.locale">
      <option :value="locale.code" v-for="locale in locales" :key="locale.code">
        🌐 {{locale.code}}
      </option>
    </select>
  </div>
</template>

<script>
import { getSupportedLocales } from './supported-locales'

export default {
  data: () => ({ locales: getSupportedLocales() })
}
</script>
